import he from "he";

export const decodeHtmlEntity = (encodedEntity: string = "") => {
  return he.decode(he.decode(encodedEntity.replace(/&amp;/g, "&").replace(/&amp;/g, "&")));
};

export const decodeHtmlEntityDeep = (value: any): any => {
  // Use the decodeHtmlEntity function for string values
  if (typeof value === "string") {
    return decodeHtmlEntity(value);
  }
  // If it's an array, decode each element
  if (Array.isArray(value)) {
    return value.map(decodeHtmlEntityDeep);
  }
  // If it's an object, decode each property
  if (typeof value === "object" && value !== null) {
    Object.keys(value).forEach((key) => {
      value[key] = decodeHtmlEntityDeep(value[key]);
    });
    return value;
  }
  return value;
};
